'use client';

import { createContext, PropsWithChildren, useContext, useRef } from 'react';
import { useStore } from 'zustand';
import { StorefrontSettingsState, createStorefrontSettingsStore } from '../stores/storefront-settings-store';

type StorefrontSettingsStoreApi = ReturnType<typeof createStorefrontSettingsStore>;

const StorefrontSettingsContext = createContext<StorefrontSettingsStoreApi | undefined>(undefined);

export const StorefrontSettingsProvider = ({ children, ...props }: PropsWithChildren<StorefrontSettingsState>) => {
	const storeRef = useRef<StorefrontSettingsStoreApi>();

	if (!storeRef.current) {
		storeRef.current = createStorefrontSettingsStore(props);
	}

	return <StorefrontSettingsContext.Provider value={storeRef.current}>{children}</StorefrontSettingsContext.Provider>;
};

export const useStorefrontSettingsStore = <T,>(selector: (store: StorefrontSettingsState) => T): T => {
	const context = useContext(StorefrontSettingsContext);

	if (!context) {
		throw new Error('useStorefrontSettingsStore must be used within a StorefrontSettingsProvider');
	}

	return useStore(context, selector);
};
